import React from 'react'
import { Button } from 'syngenta-react-components'
import { Modal } from 'syngenta-react-components'
import clear from '../../../assets/icons/clear.svg'
import warningIcon from '../../../assets/icons/warning.svg'


const Warning = props => {

  return(
    <Modal
      autoHeight
      show={true}
      handleClose={props.handleDismissWarning}
    >
      <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
        <div className='df jcsb'>
          <p className='fz16 ml16 fw600'>Confirm delete</p>
          <button className='bdnone m0 bgc-t' onClick={props.handleDismissWarning}>
            <img src={clear} alt='cancel button' />
          </button>
        </div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <img src={warningIcon} alt='warning icon' className='w50 h50'/>
        <div className='m20'>{props.warningMessage}</div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <div className='w100% tar'>
          <Button customClassName='mr10' text={props.confirmationButtonText}  clickHandler={props.handleSubmit}/>
          <Button customClassName='mr10' styleType='success' text='Cancel'  clickHandler={props.handleDismissWarning}/>
        </div>
      </div>
    </Modal>
  )
}

export default Warning